import _ from 'underscore';

// generates the key/value pairs needed to fill out the email templates
export function generateEmailContent({
  i18n,
  tagId,
  action,
  currencyCode,
  goalValueType,
}) {
  const TagId = `${tagId}`;

  const isVariant = goalValueType === 'VariantValue';

  if (_.isString(action) || isVariant) {
    const eventPropertiesObj = isVariant ? { revenue_value: '$Variable_revenue_placeholder$', currency: currencyCode } : {};
    const stringifiedEventProperties = JSON.stringify(eventPropertiesObj);
    // $Variable_revenue_placeholder$ is replaced after stringyfing the object to avoid the quotes function name
    const eventProperties = stringifiedEventProperties.replace('"$Variable_revenue_placeholder$"', 'Replace_with_Variable_Revenue_Function()');

    // values for event tag code snippet, see UPTagAndEventTagInstructionsEmail template
    return {
      TagId,
      EventAction: action || '',
      EventProperties: eventProperties,
    };
  }

  // values for UET tag snippet, see UPTagEmail and SCTagEmail templates
  return {
    TagContent: i18n.getString(_TL_('Tag creation script')),
    TagId,
  };
}
